import { RouteConfig } from "vue-router";
import { preview } from "./preview";

export const document = (): Array<RouteConfig> => [...preview()];
